<template>
  <div>
    <div class="fl mt12 mb15">
      <input class="i_w184 search_inp" type="search" v-model="keyWords" placeholder="请输入姓名或社会保障号">
      <span class="search_btn" @click="search">搜索</span>
    </div>
    <table class="table">
      <tr>
        <th v-for="tableTittle in tableTittles">{{tableTittle}}</th>
      </tr>
      <tr v-for="(item,index) in personData">
        <td><router-link :to="{name:'add',params: { type:'leaver',index: 2,status:'see',id:item.id }}" style="color: #00a5fa;">{{item.username}}</router-link></td>
        <td>{{item.sex==1?'男':'女'}}</td>
        <td>{{item.social_security_account}}</td>
        <td>{{item.mobile}}</td>
        <td>{{item.company_name}}</td>
        <td>{{item.rank_name}}</td>
        <td>{{item.work_time}}</td>
      </tr>
    </table>
    <loading v-show="loading"></loading>
    <Pagination :total="listcount" :pagesize="pagesize" :pagegroup="pagegroup" @pagechange="pagechange"></Pagination>
  </div>
</template>
<script>
  import axios from 'axios'
  import Pagination from '../libs/pagination'
  import loading from '../libs/loading'
  export default{
    name:'workerList',
    props:['index'],
    data () {
      return {
        tableTittles:['姓名','性别','社会保障号','电话','单位名称','改革时人员类别','参加工作时间'],
        typeIndex:this.$route.params.index,
        keyWords:'',
        personData:[],
        listcount:0,
        pagesize:15,
        pagegroup:7,
        pageNo:1,
        loading:true
      }

    },
    components:{
      Pagination,
      loading
    },
    methods:{
      pagechange:function(currentpage){
        this.pageNo=currentpage;
        if(this.keyWords){
          this.search();
        }else {
          this.getPersonList();
        }
      },
      getPersonList:function(){
        var that=this;
        that.personData=[];
        that.loading=true;
        function getList (){
          return axios.get('/user/getList',{
            params:{
              type:Number(that.typeIndex)+1,
              page:that.pageNo,
              limit:that.pagesize
            }
          })
        }
        axios.all([getList()])
          .then(axios.spread(function(list){
            if(list.data.code==22000) {
              that.loading = false;
              that.personData = list.data.result.users;
              that.listcount = list.data.result.total;
            }else if(list.data.code == 50001){
              window.location.href='/#/login';
            }
          }))
      },
      search:function(){
        var that=this;
        that.personData=[];
        that.loading=true;
        axios.get('/user/search',{
          params:{
            keyword:that.keyWords,
            page:that.pageNo,
            type:Number(that.typeIndex)+1
          }
        }).then((response)=>{
          if(response.data.code == 22000){
            that.loading=false;
            that.personData=response.data.result.users;
            that.listcount=response.data.result.total;
          }else if(response.data.code == 50001){
            window.location.href='/#/login';
          }
        })
      }
    },
    mounted:function(){
      this.getPersonList();
    },

  }
</script>
<style lang="less">
  .search_inp{
    padding-left: 38px!important;
    background: url("../../static/images/search.png") 10px center no-repeat;
    background-size: 18px 18px;
    color: #5f6770!important;
    border-width: 1px;
    border-style: solid;
    border-color: #e1e7f6;
    height: 28px;
    margin-right: 20px;
    font-size: 14px;
  }
  .search_inp::placeholder{
    color: #9098a2;
  }
  .search_btn{
    background-color:#00A5FA;
    display: inline-block;
    height: 28px;
    line-height: 28px;
    border-radius: 5px;
    color: #fff;
    padding:0 10px;
    cursor: pointer;
  }
  .mt12{
    margin-top: 12px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/leaverList.vue